import { SharedPartnerService } from '@/shared/api/services/partner/partner';
import type { Unternehmen } from '@/types/Partner';
import type { ZweitpruefungKonfigurationRequest } from '@/auftraggeber/types/Einstellung.ts';
import type { Nutzer, Rolle } from '@/types/Nutzer.ts';

export class PartnerService extends SharedPartnerService {
  async findeAuftraggeberNachId(
    unternehmenId: string,
    cache: boolean = false,
  ): Promise<Unternehmen> {
    return this.httpClient.get(
      `${this.partnerServiceBaseUrl}/unternehmen/auftraggeber/${unternehmenId}`,
      {
        params: { cache },
      },
    );
  }

  async hatUnternehmenSichtbeschraenkteNutzer(): Promise<boolean> {
    return this.httpClient.get(
      `${this.partnerServiceBaseUrl}/unternehmen/auftraggeber/sichtbeschraenkung`,
    );
  }

  async erstelleGesellschaft(id: string, gesellschaft: Unternehmen): Promise<Unternehmen> {
    return this.httpClient.post(
      `${this.partnerServiceBaseUrl}/unternehmen/auftraggeber/${id}/tochter`,
      { data: gesellschaft },
    );
  }

  async holeNutzerFuerZweitpruefer(unternehmenId: string, suchString?: string): Promise<Nutzer[]> {
    return this.httpClient.post(
      `${this.partnerServiceBaseUrl}/nutzerverwaltung/auftraege/zweitpruefer`,
      {
        params: { unternehmenId, suchString },
      },
    );
  }

  async updateZweitpruefungAuftrag(
    aktiv: boolean,
    konfiguration?: ZweitpruefungKonfigurationRequest,
  ): Promise<void> {
    return this.httpClient.post(
      `${this.partnerServiceBaseUrl}/unternehmen/auftraggeber/auftrag-zweitpruefung`,
      { params: { aktiv }, data: konfiguration },
    );
  }

  async holeAlleRollenMitAktivenNutzer(): Promise<Rolle[]> {
    return this.httpClient.get(
      `${this.partnerServiceBaseUrl}/nutzerverwaltung/rollen/mit-aktiven-nutzer`,
    );
  }
}
